import crossFetch from 'cross-fetch';
import { NavigationApi } from './NavigationApi';
import { ResponseError } from '@backstage/errors';
import { Redirects, redirectsApiResponseSchema } from '../types';

// these are isomorphic types that don't require @backstage/core-plugin-api
type DiscoveryApi = { getBaseUrl(pluginId: string): Promise<string> };
type FetchApi = { fetch: typeof fetch };

export class NavigationClient implements NavigationApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  public constructor(deps: {
    discoveryApi: DiscoveryApi;
    fetchApi?: FetchApi;
  }) {
    const { discoveryApi, fetchApi } = deps;
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi ?? { fetch: crossFetch };
  }

  public async getRedirects(): Promise<Redirects> {
    const baseUrl = await this.discoveryApi.getBaseUrl('navigation');
    const response = await this.fetchApi.fetch(`${baseUrl}/redirects`);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    const data = await response.json();
    return redirectsApiResponseSchema.parse(data).redirects;
  }
}
